import { React, Component, Container, Config, _ } from "utils";
import {
  Menu,
  Loading,
  Pavilion,
  StandLinks,
  PavilionMenu,
  Ratio,
  PavilionTitle,
} from "components";
import { withRouter } from "react-router-dom";
import {
  App,
  FairStore,
  SelectedPavilionStore,
  Creators,
  ScrollStore,
  RatioStore,
} from "model";

class PavilionPage extends Component {
  static getStores() {
    return [SelectedPavilionStore];
  }

  static calculateState(state, props) {
    var selected = SelectedPavilionStore.getSelectedPavilion();

    if (selected) {
      var state = {
        pavilion: selected,
      };

      return state;
    } else {
      return {
        pavilion: null,
      };
    }
  }

  render() {
    var { pavilion } = this.state;
    var { history } = this.props;

    return (
      <div className="page homepage pavilion">
        <Menu />
        <PavilionMenu />
        <Content history={history}>
          <Loading visible={pavilion == null} description={_("Loading")} />
          <Ratio>
            <Pavilion data={pavilion} parent={this} history={history} />
          </Ratio>
        </Content>

        <StandLinks data={pavilion} />
        <PavilionTitle />
      </div>
    );
  }
}

export class Content extends Component {
  setContentRef = (content) => {
    this.pavilion = content;
  };

  componentDidMount = () => {
    this.timer = setInterval(this.focusSelected, 500);

    $(this.pavilion).on("scroll", this.handleScroll);
    $(window).on("vv.scrollTo", this.scrollToSelectedStand);

    this.zoom = CSS.supports("zoom:0.5");
  };

  componentWillUnmount = () => {
    $(this.pavilion).off("scroll", this.handleScroll);
    $(window).off("vv.scrollTo", this.scrollToSelectedStand);
  };

  focusSelected = () => {
    var stand = SelectedPavilionStore.getSelectedStandSlug();

    if (SelectedPavilionStore.isReady()) {
      var offset = ScrollStore.getOffset();

      if (offset > 0) {
        clearTimeout(this.timer);
        $(this.pavilion).scrollLeft(offset);
      } else {
        if (this.isFocused(stand) || stand == "first") {
          clearTimeout(this.timer);
        } else {
          this.scrollToSelected(stand);
        }
      }
    }
  };

  isFocused = (slug) => {
    var view = $(".stand." + slug);

    if (view.length > 0) {
      var ratio = RatioStore.getRatio();

      var offset = view.position().left;
      var scaledOffset = offset * ratio;

      var diff =
        Math.abs($(this.pavilion).scrollLeft()) - Math.abs(scaledOffset);

      return Math.abs(diff) < 10;
    } else {
      return false;
    }
  };

  scrollToSelected = (stand) => {
    var view = $(".stand." + stand);

    if (view.length > 0) {
      var ratio = RatioStore.getRatio();

      if (this.zoom == false) {
        ratio = 1;
      }

      var offset = view.position().left;

      var centerOffset = 0;

      var standWidth = view.width() * RatioStore.getRatio();
      var windowWidth = $(window).width();

      if (windowWidth > standWidth) {
        centerOffset = (windowWidth - standWidth) / 2;
      }

      var scaledOffset = offset * ratio - centerOffset;

      //suspend scroll listener
      $(this.pavilion).off("scroll", this.handleScroll);
      this.slug = stand;

      $(window).trigger("vv.scrollSpy", false);

      var scrollTo =
        navigator.platform === "iPhone"
          ? scaledOffset
          : offset - Math.max(centerOffset, 0);

      $(this.pavilion).animate(
        {
          scrollLeft: scrollTo,
        },
        () => {
          //resume scroll listener
          $(this.pavilion).on("scroll", this.handleScroll);
          $(window).trigger("vv.scrollSpy", true);
        }
      );

      return true;
    }

    return false;
  };

  handleScroll = () => {
    var ratio = RatioStore.getRatio();

    if (this.zoom == false) {
      ratio = 1;
    }

    var pavilion = $(this.pavilion);
    var offset = pavilion.scrollLeft();

    Creators.scrollChanged(offset);

    var halfScreen = pavilion.width() / 2;
    var totalOffset = offset + halfScreen;

    if (navigator.platform === "iPhone") {
      totalOffset = totalOffset / ratio;
    }

    var stand = null;
    var max = 0;

    $(".stand").each(function(index, item) {
      var itemOffset = $(item).position().left;

      if (itemOffset >= max && itemOffset < totalOffset) {
        max = itemOffset;
        stand = item;
      }
    });

    var slug = $(stand).data("slug");
    var pavilion = SelectedPavilionStore.getSelectedPavilionSlug();

    if (this.slug != slug && pavilion != null) {
      this.slug = slug;
      var { history } = this.props;
      var url = App.standUrl(pavilion, slug);
      history.replace(url);
    }
  };

  scrollToSelectedStand = (event, slug) => {
    this.scrollToSelected(slug);
  };

  handleWheel = (args) => {
    var box = $(this.pavilion);

    var delta = args.deltaY;
    var left = box.scrollLeft();

    box.scrollLeft(left + delta);
  };

  render() {
    var { children } = this.props;

    return (
      <div
        className="content"
        onWheel={this.handleWheel}
        ref={this.setContentRef}
      >
        {children}
      </div>
    );
  }
}

export default withRouter(Container.create(PavilionPage, { withProps: true }));



// WEBPACK FOOTER //
// ./src/modules/pages/pavilionpage.js